import { on } from '@ngrx/store';

import {
  ManageSurveyActions,
  ManageSurveyApiActions,
} from './manage-survey.actions';
import { ManageSurveyState } from './manage-survey.model';

export const TRAFFIC_CHANNEL_HANDLERS = [
  on(
    ManageSurveyActions.loadTrafficChannels,
    (state): ManageSurveyState => ({
      ...state,
      trafficChannelsLoading: true,
      trafficChannelsError: null,
    }),
  ),

  on(
    ManageSurveyActions.resetTrafficChannels,
    (state): ManageSurveyState => ({
      ...state,
      trafficChannels: [],
      trafficChannelsLoading: false,
      trafficChannelsError: null,
      tcStatusChangingIds: [],
    }),
  ),

  on(
    ManageSurveyApiActions.loadTrafficChannelsSuccess,
    (state, { trafficChannels }): ManageSurveyState => ({
      ...state,
      trafficChannels,
      trafficChannelsLoading: false,
      trafficChannelsError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.loadTrafficChannelsFailure,
    (state, { error }): ManageSurveyState => ({
      ...state,
      trafficChannels: [],
      trafficChannelsLoading: false,
      trafficChannelsError: error,
    }),
  ),

  on(
    ManageSurveyActions.setTrafficChannelStatus,
    (state, { surveyId }): ManageSurveyState => ({
      ...state,
      tcStatusChangingIds: [...state.tcStatusChangingIds, surveyId],
      trafficChannelsError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.setTrafficChannelStatusSuccess,
    (state, { surveyId, status }): ManageSurveyState => ({
      ...state,
      trafficChannels: state.trafficChannels.map((channel) =>
        channel.id === surveyId ? { ...channel, status } : channel,
      ),
      trafficChannelsError: null,
      tcStatusChangingIds: state.tcStatusChangingIds.filter(
        (id) => id !== surveyId,
      ),
    }),
  ),

  on(
    ManageSurveyApiActions.setTrafficChannelStatusFailure,
    (state, { surveyId }): ManageSurveyState => ({
      ...state,
      tcStatusChangingIds: state.tcStatusChangingIds.filter(
        (id) => id !== surveyId,
      ),
    }),
  ),

  on(
    ManageSurveyActions.launchTrafficChannel,
    (state): ManageSurveyState => ({
      ...state,
      creatingTrafficChannel: true,
      trafficChannelCreationError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.launchTrafficChannelSuccess,
    (state, { trafficChannels }): ManageSurveyState => ({
      ...state,
      trafficChannels,
      creatingTrafficChannel: false,
      psidUploadLoading: false,
      psidUploadError: null,
      psidUploadFilePath: null,
      psidUploadUniqCount: null,
      psidUploadTotalCount: null,
    }),
  ),

  on(
    ManageSurveyApiActions.launchTrafficChannelFailure,
    (state, { error }): ManageSurveyState => ({
      ...state,
      creatingTrafficChannel: false,
      trafficChannelCreationError: error,
    }),
  ),

  on(
    ManageSurveyActions.uploadPsidFile,
    (state): ManageSurveyState => ({
      ...state,
      psidUploadLoading: true,
      psidUploadError: null,
    }),
  ),

  on(
    ManageSurveyApiActions.uploadPsidFileSuccess,
    (
      state,
      { filePath, uniqPsidCount, uploadedPsidCount },
    ): ManageSurveyState => ({
      ...state,
      psidUploadLoading: false,
      psidUploadError: null,
      psidUploadFilePath: filePath,
      psidUploadUniqCount: uniqPsidCount,
      psidUploadTotalCount: uploadedPsidCount,
    }),
  ),

  on(
    ManageSurveyApiActions.uploadPsidFileFailure,
    (state, { error }): ManageSurveyState => ({
      ...state,
      psidUploadLoading: false,
      psidUploadError: error,
      psidUploadFilePath: null,
      psidUploadUniqCount: null,
      psidUploadTotalCount: null,
    }),
  ),

  on(
    ManageSurveyActions.clearPsidFile,
    (state): ManageSurveyState => ({
      ...state,
      psidUploadLoading: false,
      psidUploadError: null,
      psidUploadFilePath: null,
      psidUploadUniqCount: null,
      psidUploadTotalCount: null,
      creatingTrafficChannel: false,
      trafficChannelCreationError: null,
    }),
  ),
];
